export type SpecRow = { key: string; value: string };

export type Section = {
  id: string;
  name: string;
  title: string;
  titleMono?: boolean;
  swatches: string[];
  art?: "circles" | "grid-not-chat" | "contact-rings" | "photo" | "photo-hero";
  photoSrc?: string;
  photoCaption?: { before: string; href: string; label: string; after: string };
  bg?: string;
  spec?: { label: string; rows: SpecRow[] };
  body: BodyNode[];
};

export type BodyNode =
  | { kind: "p"; text: string }
  | { kind: "p-link"; before: string; href: string; label: string; after: string }
  | { kind: "p-icon-link"; before: string; href: string; icon: "x"; after: string }
  | { kind: "mailto"; address: string }
  | { kind: "social"; href: string; label: string };

export const sections: Section[] = [
  {
    id: "spicadust",
    name: "spicadust",
    title: "spicadust_",
    titleMono: true,
    swatches: [],
    art: "photo-hero",
    photoSrc: "/front-page.jpg",
    body: [
      { kind: "p", text: "Spicadust is yet another software company building nerdy, beautiful stuff. I guess." },
    ],
  },
  {
    id: "philosophy",
    name: "philosophy",
    title: "philosophy",
    swatches: [],
    art: "photo",
    photoSrc: "/philosophy.png",
    photoCaption: {
      before: "generated with ",
      href: "http://generativ.design",
      label: "generativ.design",
      after: "",
    },
    spec: {
      label: "02 · STANCE",
      rows: [
        { key: "section", value: "philosophy" },
        { key: "topic",   value: "llm" },
      ],
    },
    body: [
      { kind: "p", text: "LLMs are infrastructure, not the product. Applications should be as simple as they can be." },
    ],
  },
  {
    id: "dusto",
    name: "dusto",
    title: "dusto",
    swatches: [],
    art: "circles",
    spec: {
      label: "03 · PRODUCT",
      rows: [
        { key: "section", value: "dusto" },
        { key: "kind",    value: "email intel." },
        { key: "status",  value: "live" },
      ],
    },
    body: [
      { kind: "p-icon-link", before: "A quiet email agent that reads what arrives and surfaces what matters. join us on ", href: "https://x.com/dustoapp", icon: "x", after: "" },
      { kind: "p-link", before: "", href: "http://dusto.app", label: "dusto.app", after: " ->" },
    ],
  },
  {
    id: "contact",
    name: "get in touch",
    title: "get in touch",
    swatches: [],
    art: "photo",
    photoSrc: "/get_in_touch.png",
    photoCaption: {
      before: "generated with ",
      href: "http://generativ.design",
      label: "generativ.design",
      after: "",
    },
    spec: {
      label: "04 · INFO",
      rows: [
        { key: "section", value: "contact" },
        { key: "method",    value: "email" },
      ],
    },
    body: [
      { kind: "mailto", address: "contact@spicadust.com" },
      { kind: "social", href: "https://x.com/AirswitchAsa", label: "@AirswitchAsa" },
    ],
  },
];
